import './styles.scss';
import { Navigate, NavLink } from 'react-router-dom';
import CMSGroves from '../CMSGroves/'
import CMSParks from '../CMSParks/'
import CMSCSVImport from '../CMSCSVImport/'
import AddGroveSlugs from '../AddGroveSlugs/'
import CMSGroveForm from '../CMSGroves/CMSGroveForm';
import { Routes, Route } from 'react-router-dom';
import { useAuth, useFirestore } from 'reactfire';
import { doc, collection, onSnapshot } from 'firebase/firestore';
import { useEffect } from 'react';
import { Tooltip } from 'react-tooltip';

const signOut = auth => auth.signOut().then(() => console.log('signed out'));

export default function CMSHome(props) {

  const auth = useAuth()
  const firestore = useFirestore()
  // const { data: user } = useFirestoreDocData(userDoc);
  // console.log(auth)
  // console.log(user)
  useEffect(() => {
    const userCollection = collection(firestore, 'users');
    const userDoc = doc(userCollection, auth.currentUser.uid);
    auth.onAuthStateChanged(user => {
      onSnapshot(userDoc, d => {
        console.log('token')
        if (user) {
          user.getIdToken(true)
        }
      })
    })
  }, [auth, firestore])

  const isAdmin = auth && auth.currentUser && auth.currentUser.email === 'savetheredwoods@gmail.com'

  return (
    <div className='CMSHome'>
      {isAdmin ?
        <nav>
          <NavLink to='/cms/groves' end>Groves</NavLink>
          <NavLink to='/cms/parks'>Parks</NavLink>

          <NavLink to='/cms/csvImport'>csvImport</NavLink>
          <NavLink to='/cms/addGroveSlugs'>Add Grove Slugs</NavLink>
          <button className='link' onClick={() => signOut(auth)} href='#'>Sign out</button>
        </nav>
       : null }
      <div className='content'>
        <Routes>
          <Route path='groves' element={<CMSGroves />} />
          <Route path='groves/add' element={<CMSGroveForm isAdmin={isAdmin} />} />
          <Route path='groves/edit/:id' element={<CMSGroveForm isAdmin={isAdmin} />} />
          <Route path='parks' element={<CMSParks />} />
          <Route path='csvImport' element={<CMSCSVImport />} />
          <Route path='addGroveSlugs' element={<AddGroveSlugs />} />
          <Route path="*" element={
            <Navigate to='/cms/groves' replace />
          } />
        </Routes>
      </div>
      <Tooltip />
    </div>
  )
}
